import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateHelper } from '@app/_helpers';
import { AuthenticationService } from '@app/_services/authentication.service';
import { CartItem } from '@interfaces/cart-item';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CartService } from '@services/cart.service';
import { OffcanvasCartService } from '@services/offcanvas-cart.service';
import { RootService } from '@services/root.service';
import * as _ from 'lodash';
import { CurrencyFormatPipe } from '../../../../shared/pipes/currency-format.pipe';
import { BookingDetailsViewerComponent } from '../../../../shared/components/booking-details/booking-details.component';
import { OptionsDetailsViewerComponent } from '../../../../shared/components/options-details/options-details.component';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';

export type DropcartType = 'dropdown' | 'offcanvas';

@Component({
    selector: 'app-header-dropcart',
    templateUrl: './dropcart.component.html',
    styleUrls: ['./dropcart.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, IconComponent, NgFor, RouterLink, OptionsDetailsViewerComponent, BookingDetailsViewerComponent, NgClass, AsyncPipe, CurrencyFormatPipe, TranslateModule]
})
export class DropcartComponent {
    removedItems: CartItem[] = [];
    cartItems;
    cartObject;
    userDetails;
    image = 'assets/images/nologo.png';
    @Input() type: DropcartType = 'dropdown';

    @Output() closeMenu: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        public state: OffcanvasCartService,
        public cart: CartService,
        public root: RootService,
        private authService: AuthenticationService,
        public route: Router,
        public translate: TranslateService,
        public translateHelper: TranslateHelper
    ) { }

    remove(item: any, cartId): void {
        let params: any = {};
        params = {
            itemId: item.itemId,
            amount: 0
        }

        this.cart.updateCartItem(params).subscribe((data) => {
            if (_.isEmpty(data.cart)) {
                this.cart.clearCartItems(cartId);
            }
        });
    }

    close(): void {
        this.state.close();
    }

    ngOnInit(): void {
    }
    /**
    * @desc return image object key
    * @param {*} imageObject
    * @returns
    * @memberof SearchComponent
    */
    imagebObjectKey(imageObject) {
        return _.findKey(imageObject);
    }
}
